import { Button, Stack } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import InputField from '../../../../components/customElements/InputField/InputField'
import { addComment } from '../../../../services/ApiService'
import singleRequestStore from '../../store/SingleRequestStore'

const AddCommentForm = ({ disabled }: { disabled: boolean }) => {
  const intl = useIntl()
  const { request, getComments } = singleRequestStore
  const [comment, setComment] = React.useState('')

  const onSave = async () => {
    if (!request) return

    await addComment({
      orderId: request.id,
      text: comment,
    }).then(() => {
      setComment('')
      getComments(request.id)
    })
  }

  const btnDisabled = disabled

  return (
    <Stack spacing={'16px'} paddingX={'16px'}>
      <Stack spacing={'10px'}>
        <InputField
          multiline
          value={comment}
          onChange={(e: React.ChangeEvent<any>) => setComment(e.target.value)}
          rows={3}
          fullWidth
          territorySelect={false}
          placeholder={intl.formatMessage({ id: 'Введите комментарий' })}
          sx={{
            padding: '0',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: disabled ? '#A5A5A5!important' : 'rgb(22,104,185)',
              },
              '&:hover fieldset': {
                borderColor: 'rgb(22,104,185)',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'rgb(22,104,185)',
              },
            },
          }}
          disabled={disabled}
        />
      </Stack>
      <Stack direction={'row'} spacing={'8px'}>
        <Button
          color={'primary'}
          variant={'contained'}
          onClick={onSave}
          fullWidth
          disabled={btnDisabled || !comment}
          sx={{
            backgroundColor: btnDisabled ? '#A5A5A5!important' : undefined,
            color: btnDisabled ? '#E0DFDF!important' : undefined,
          }}
        >
          <FormattedMessage id={'Добавить'} />
        </Button>
        <Button
          color={'primary'}
          variant={'outlined'}
          onClick={() => setComment('')}
          fullWidth
          disabled={btnDisabled || !comment}
          sx={{
            borderColor: btnDisabled ? '#A5A5A5!important' : undefined,
            color: btnDisabled ? '#A5A5A5!important' : undefined,
          }}
        >
          <FormattedMessage id={'Очистить'} />
        </Button>
      </Stack>
    </Stack>
  )
}

export default observer(AddCommentForm)
